import { Pagination } from '@mui/material'
import { UserTable } from 'components'
import { chunk } from 'lodash'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PaginatorHolder } from '../styled'
import { AllUsersContainer } from './styled'

interface IAllUsersProps {
  content: TableItem[]
}

const AllUsers = ({ content }: IAllUsersProps) => {
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [itemsChunk, setItemsChunk] = useState<TableItem[][]>([])
  const [pages, setPages] = useState<number[]>([])

  const navigate = useNavigate()

  const handlePageChange = (_: unknown, page: number) => {
    setCurrentPage(page)
  }

  const userEdit = (userId?: string | number) => {
    navigate(`/user/${userId}`)
  }

  const configPages = (content: TableItem[]) => {
    const _chunk = chunk(content, 5)
    const _pages = []
    setItemsChunk(_chunk)
    for (const i of _chunk) {
      _pages.push(_chunk.indexOf(i) + 1)
    }
    setPages(_pages)
  }

  useEffect(() => {
    configPages(content)
  }, [content])

  return (
    <AllUsersContainer>
      <UserTable
        keyIndex={4}
        onEdit={userEdit}
        columns={[
          'Name',
          'Phone',
          'Access',
          'Level',
          '',
          null as unknown as string
        ]}
        items={itemsChunk[currentPage - 1]}
      />

      <PaginatorHolder>
        {pages.length > 0 && (
          <Pagination count={pages.length} onChange={handlePageChange} />
        )}
      </PaginatorHolder>
    </AllUsersContainer>
  )
}

export default AllUsers
